import { defaultLocale, type LocaleCode, supportedLocales } from '../../config/locales';

const DEFAULT_LANG_SENTINELS: ReadonlySet<string> = new Set(['', 'default']);

export function resolveLang(rawLang: string | null | undefined): LocaleCode {
  if (rawLang == null || DEFAULT_LANG_SENTINELS.has(rawLang)) {
    return defaultLocale;
  }
  if ((supportedLocales as readonly string[]).includes(rawLang)) {
    return rawLang as LocaleCode;
  }
  throw new Error(`Unknown lang: ${rawLang}`);
}
